import { type ReactNode, type JSX } from 'react';
import { BodyS } from '../../../typography';
import { useOptionButtonContainerStyles } from './optionButtonContainer.styles';
import { useTheme } from '../../../theme';

export type OptionButtonContainerProps = {
  option?: ReactNode;
  label: string;
  onClick?: () => void;
};

export const OptionButtonContainer = ({
  option,
  label,
  onClick,
}: OptionButtonContainerProps): JSX.Element => {
  const theme = useTheme();
  const styles = useOptionButtonContainerStyles();
  return (
    <button css={styles.container} onClick={onClick} type='button'>
      {option}
      <BodyS
        tag='span'
        fontWeight='medium'
        color={theme.button.secondary.label}
      >
        {label}
      </BodyS>
    </button>
  );
};
